import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-more-information',
  templateUrl: 'more-information.component.html',
  styleUrls: ['./more-information.component.scss'],
})
export class MoreInformationComponent implements OnInit {
  @Input() public titleModal = 'Mais Informações';

  @Input()
  public formMoreInformation: FormGroup;

  public formItems: any[] = [];
  public options = [{value: 'Comum', id: 0}, {value: 'Biometria', id: 1}, {value: 'NFC', id: 2}];
  public tags = [{value: 'Comum', id: 0}, {value: 'Biometria', id: 1}];


  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initialForm();
  }

  public initialForm(): void {
    this.formMoreInformation = this.fb.group({
      id: [null],
      condominium_value: [null],
      iptu_value: [null],
      iptu_free: [false],
      keys_types: [],
      keys_location: [null],
    });
  }

  public setTags(event) {
    this.tags = event;
    this.tags = Object.assign(this.tags, event);
  }

  public validationIptu() {
    if (this.formMoreInformation.get('iptu_free').value) {
      this.formMoreInformation.get('iptu_value').disable();
    } else {
      this.formMoreInformation.get('iptu_value').enable();
    }
  }

}
